module.exports = __webpack_public_path__ + "media/images/hero/glyph-3-e649d7bb7e4905939ff720f896f0b394.svg";